<template>
	<div>
		<div class="w-tabs">
			<div class="tabs">
				<div class="tab active" @click="showDlg(1)">新增</div>
			</div>
		</div>
		<div class="table-wrap">
			<el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border :data="list.data" v-loading="isLoading">
				<el-table-column prop="serviceType"  label="服务项目" width="140"></el-table-column>	
				<el-table-column prop="expectServiceTime" label="计划服务时间" show-overflow-tooltip></el-table-column>			
				<!-- <el-table-column prop="expectServicer" label="计划服务人" width="100"></el-table-column> -->
				<el-table-column label="实际服务时间" >
					<template slot-scope="scope">
						{{scope.row.serviceTime?scope.row.serviceTime:"——"  }}
					</template>
				</el-table-column>	
				<el-table-column label="实际服务人" width="160">
					<template slot-scope="scope">
						{{scope.row.servicer?scope.row.servicer:"——"  }}
					</template>
				</el-table-column>	
								
				<el-table-column prop="state" label="服务状态" width="100" ></el-table-column>
				
				<el-table-column label="操作" width="190">
					<template slot-scope="scope">
						<div class="tab-action">
							<template v-if="scope.row.state !=='已完成'">
								<el-tooltip content="修改" placement="top" :enterable="false"><i class="icon-edit" @click="showDlg(2, scope.row)"></i></el-tooltip>
							</template>
							<el-tooltip content="查看" placement="top" :enterable="false"><i class="icon-assigning" @click="openDrawer(scope.row)"></i></el-tooltip>
							<el-popconfirm confirmButtonText='删除' title="确定删除吗？" @confirm="delItem(scope.row)">
								<el-tooltip content="删除" slot="reference" placement="top" :enterable="false"><i class="el-icon-delete"></i></el-tooltip>
							</el-popconfirm>								
						</div>
					</template>
				</el-table-column>
				
			</el-table>	
			<div class="pagination">
				<el-row>
					<el-col :span="12">
						<div class="record">当前是第<span v-text="(filter.pageNumber-1)*filter.pageSize+1"></span>条至第<span v-text="(filter.pageNumber-1)*filter.pageSize+filter.pageSize"></span>数据</div>
						<div class="record">总计<span v-text="list.total"></span>条记录</div>
					</el-col>
					<el-col :span="12" style="text-align: right;">
						<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next" :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"  prev-text="上一页" next-text="下一页" :current-page="list.current" :page-size="filter.pageSize" :total="list.total" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
					</el-col>
				</el-row>
			</div>
		</div>		

		<el-drawer size="660px" :show-close="false" :visible="drawerAct">
			<template slot="title">
				<div class="el-drawer-close" @click="closeDlg"><i class="el-icon el-icon-arrow-left"></i>返回</div>
				服务详情
			</template>
			<div>
				<div style="padding: 0 32px;">
					评估单
					<el-button style="margin-left:8px" type="primary" plain @click="openQuestionnaire()">新增评估单</el-button>
				</div>
				<div class="step-title" v-for="item in questionResult" :key="item.id">
					<div>
						{{ item.name }}
						<el-tag v-if="item.finishTime" size="mini" style="margin-left: 10px">已完成</el-tag>
						<el-tag v-else type="info" size="mini" style="margin-left: 10px">未完成</el-tag>
					</div>
					<div class="rigBox">
						<router-link class="el-link el-link--primary" target="_blank" :to="{name: 'QuestForm', params: {key: item.qcId}, query: { rid: item.id, t: my.token }}">
							<i class="icon-research"></i>
							<span style="padding-left: 4px;">{{ item.finishTime?'查看评估单':'填写评估单' }}</span>
						</router-link>
						<el-popconfirm confirmButtonText='删除' title="确定删除吗？"  @confirm="delQuest(item.id)">
							<el-tooltip slot="reference" class="item" effect="dark" content="删除">
								<el-button type="text" ><i class="el-icon-delete" style="font-size:20px"></i></el-button>
							</el-tooltip>
						</el-popconfirm>
					</div>
					<!-- <el-link type="primary" icon="icon-research" :underline="false"></el-link> -->
				</div>
			</div>
			
			<questionnaire :patientId="patientId" :recordType="4" :customerId="customerId" :recordId="cid" :visible="questionnaireType" @close="closeQuestionnaire" :writeQuestionnaire.sync="writeQuestionnaire" showType="service"></questionnaire>
			<div class="drawer-content form-schedule">
				<template>
					<el-form class="ver" ref="form1" label-width="120px" :rules="serviceRules.rules" :model="form1">
						<el-form-item label="服务项目" prop="serviceType">
							<el-select
								:style="{ width: '300px' }"
								placeholder="请选择服务项目"
								v-model="form1.serviceType"
								>
								<el-option
									v-for="(item, index) in options"
									:key="index"
									:label="item.name"
									:value="item.id"
								/>
							</el-select>
						</el-form-item>
						<el-form-item label="实际服务日期" prop="serviceTime">
							<el-date-picker
							v-model="form1.serviceTime"
							type="date"
							placeholder="选择日期">
							</el-date-picker>
						</el-form-item>
						<!-- <el-form-item type="input" label="实际服务护士" prop="servicer">
							<el-input type="input" size="small" rows="5" resize="none"  v-model.trim="form1.servicer"></el-input>
						</el-form-item>-->
						<el-form-item label="实际服务护士" prop="servicer">
							<el-select size="small" filterable clearable placeholder="请选择" v-model="form1.servicer">
								<el-option v-for="(item,index) in managerList" :key="index" :label="item.name" :value="item.name"></el-option>
							</el-select>
						</el-form-item>
					</el-form>
				</template>
			</div>
			<div class="action">
				<el-button type="primary" :loading="isLoading" @click="saveForm1">提交</el-button>
			</div>
		</el-drawer>
		<el-dialog :title="titState=='add'?'新增延续性护理服务':'修改延续性护理服务'" width="560px" center :visible.sync="dlgAct" :close-on-click-modal="false">
			<el-form ref="form" label-width="120px" :rules="expectServiceRules.rules" :model="form">
				<el-form-item label="服务项目" prop="serviceType">
					<el-select
						:style="{ width: '100%' }"
						placeholder="请选择服务项目"
						v-model="form.serviceType"
						>
						<el-option
							v-for="(item, index) in options"
							:key="index"
							:label="item.name"
							:value="item.id"
						/>
					</el-select>
				</el-form-item>
				<el-form-item label="计划服务日期" prop="expectServiceTime">
					<el-date-picker
					v-model="form.expectServiceTime"
					type="date"
					placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
				<!-- <el-form-item type="input" label="计划服务护士" prop="expectServicer">
					<el-input type="input" size="small" rows="5" resize="none" v-model.trim="form.expectServicer"></el-input>
				</el-form-item>	 -->
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini"  :loading="isLoading" @click="closeDlg">关闭</el-button>
				<el-button type="primary" size="mini" :loading="isLoading" @click="saveForm">保存</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import api from '@/service/api.js';
import mixin from '@/views/mixin';
import dayjs from 'dayjs';
import Questionnaire from './questionnaire/questionnaire.vue';


export default {
  mixins: [mixin],
  components:{Questionnaire},
	data(){
		return {
			noSidebar: true,
			serviceRules: {
				active:false,
				rules: {
					serviceType: {required: true, message: '请选择服务项目'},
					serviceTime: {required: true, message: '请选择实际服务日期'},
					servicer: {required: true, message: '请选择实际服务护士'},
				}
			},
			expectServiceRules:{
				active:false,
				rules: {
					serviceType: {required: true, message: '请选择服务项目'},
					expectServiceTime: {required: true, message: '请选择计划服务日期'},
					// expectServicer: {required: true, message: '请输入计划服务护士'},
				}
			},
			list: {
				current: 1,
				total: 0,
				pageSize: 0,
				data: null
			},
			filter: {
				dataType:'',
				recordId:'',
				pageNumber: 1,
				pageSize: 10
			},
			form: {
				dataType:'',
				// expectServicer:'',
				expectServiceTime:'',
				patientId:'',
				recordId:'',
				// servicer:'',
				// serviceTime:null,
				serviceType:'',
				state:0
			},
			form1: {
				// dataType:'',
				// expectServicer:'',
				// expectServiceTime:'',
				// patientId:'',
				// recordId:'',
				servicer:'',
				serviceTime:null,
				serviceType:'',
				state:0
			},
			questionnaireType: false,
			writeQuestionnaire:false,//是否填写问卷
			dlgAct:false,
			drawerAct:false,
			options:[
			{
				name:'引流管',
				id:1
			},
			{
				name:'PICC',
				id:2
			},
			{
				name:'输液港',
				id:3
			},
			{
				name:'透析导管',
				id:4
			},
			{
				name:'留置尿管',
				id:5
			},
			{
				name:'留置胃管',
				id:6
			},
			{
				name:'压力性损伤护理',
				id:7
			},
			{
				name:'糖尿病足护理',
				id:8
			},
			{
				name:'造口护理',
				id:9
			},
			{
				name:'产褥期自我护理',
				id:10
			},
			{
				name:'新生儿护理',
				id:11
			},
			{
				name:'产科上门服务',
				id:12
			},
			{
				name:'线上指导',
				id:13
			}
			],
			titState:'add',
			recordId:'',
			cid:0,//延续性护理服务id
			customerId:0,
			questionResult:[],
			managerList: [],
			fid:'',
		}
	},
	created() {
		this.init();
	},
	mounted(){
		document.addEventListener('visibilitychange', this.handleVisiable)  
	},
	destroyed() {  
			document.removeEventListener('visibilitychange', this.handleVisiable);
			this.writeQuestionnaire=false;
		},
	methods: {
		async init() {
			this.patientId = +this.$route.query.patientId;
			this.fid=this.$route.query.fid;
			// this.filter.patientId = this.patientId;
			this.form.patientId=this.patientId; 
			this.filter.dataType = +this.$route.query.datasources || 0;
			this.form.dataType = +this.$route.query.datasources || 0;
			let res=await api.getPatient({patientId: this.patientId});
			if(res.code==1000){
				// this.filter.recordId=res.data.id;
				// this.form.recordId=res.data.id;
				this.recordId=res.data.id;
				this.customerId=res.data.customerId||0;
			}
			let result=await api.getInhospitalInfo(this.fid);
			// console.log(result,'-------',this.fid);
			if(result.code==1000){

				this.form.recordId=result.data.id;
				this.form1.recordId=result.data.id;
				this.filter.recordId=result.data.id;
			}
			
			// 获取 疾病管理师下拉
			api.getComboboxUserList({roleId: 3}).then((res)=>{
				if (res.code == 1000 && res.data) {
					this.managerList = res.data;
				}
			})
			await this.loadList();
		},
		async loadList() {
			this.isLoading = true;
			let res = await api.getContinuityCareByRecordId(this.filter);
			if (res.code == 500) {return;}

			this.list.total = +res.total;
			this.list.current = this.filter.pageNumber;
			this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
			if (res.data) {
				res.data.forEach((item)=>{
					item.expectServiceTime = dayjs(item.expectServiceTime).format('YYYY-MM-DD');
					item.serviceTime = item.serviceTime?dayjs(item.serviceTime).format('YYYY-MM-DD'):null;
				})
				this.list.data = res.data;
			}
			this.isLoading = false;
		},
		async openDrawer(item){
			this.drawerAct=true;
			this.isLoading = true;
			let res = await api.getContinuityCareById({continuityCareId:item.id});
			this.isLoading = false;
			if (res.code != 1000) {return this.$message.error(res.message);}
			this.cid=res.data.id;
			this.form1={
				...this.form,
				serviceType:res.data.serviceType,
				serviceTime:res.data.serviceTime,
				servicer:res.data.servicer,
				id:res.data.id,
			}
			this.getQuestionResult(item)
			this.titState='edit2'
		},
		// 查询问卷结果
		async getQuestionResult(item){
			let obj={
				customerId:this.customerId,
				recordId:item.id?item.id:item,
				recordType:4
			}
			let res = await api.getQuestionresultList(obj);
			if (res.code != 1000) {return this.$message.error(res.message);}
			this.questionResult=res.data;
		},
		async showDlg(v, item) {
			let res;
			switch (v) {
				case 1: 
					this.form.serviceType='';
					this.form.expectServiceTime='';
					this.form.expectServicer='';
					// this.$refs['form'].resetFields();
					this.titState='add';
					break;
				case 2:
					this.titState='edit';
					this.isLoading = true;
					res = await api.getContinuityCareById({continuityCareId:item.id});
					this.isLoading = false;
					if (res.code != 1000) {return this.$message.error(res.message);}
					this.form={
						...this.form,
						serviceType:res.data.serviceType,
						expectServiceTime:res.data.expectServiceTime,
						// expectServicer:res.data.expectServicer,
						id:res.data.id,

					}
					// console.log(item,'-------iite',this.form);
					
					break;
			}
			this.dlgAct=true;
		},
		closeDlg() {
			this.dlgAct = false;
			this.drawerAct=false;
		},
		openQuestionnaire() {
				this.questionnaireType = true;
			},
		closeQuestionnaire() {
				// if(this.writeQuestionnaire&&this.itemAdvice.followupState==3){
				// 	this.saveForm(3);
				// }
				this.questionnaireType = false;
				this.getQuestionResult(this.cid);
				this.init();
		},	
		async saveForm() {
			this.$refs['form'].validate(async (valid,value)=>{
				if (valid) {
					this.form.expectServiceTime = dayjs(this.form.expectServiceTime).format('YYYY-MM-DD 00:00:00');					
					if(this.titState=='add'){
						// 新增
						this.isLoading = true;
						let res = await api.addContinuityCare(this.form);
						this.isLoading = false;
						if (res.code != 1000) {
							return this.$message.error(res.message);
						}		
						this.$message.success('保存成功');
				
					} else if(this.titState=='edit'||this.titState=='edit2'){
						let obj;let serviceid;
						if(!Number(this.form.serviceType)){
							serviceid=this.options.find(ite=>ite.name==this.form.serviceType).id;
							obj={
								...this.form,
								serviceType:serviceid
							}
						} else {
							obj={...this.form}
						}
						if(this.titState=='edit2'){
							obj.state=1;
						}
						// console.log(obj,'=======',this.form);
						this.isLoading = true;
						let res = await api.updateContinuityCare(obj);
						if (res.code != 1000) {return this.$message.error(res.message);}
						this.isLoading = false;
						this.$message.success('修改成功');
					}
					this.closeDlg();
					this.$refs['form'].resetFields();
					this.form.servicer='';
					// this.form.expectServicer='';
					this.form.expectServiceTime='';
					setTimeout(() => {
						this.loadList();
					}, 500);
				}
			})
			
		},
		async saveForm1() {
			this.$refs['form1'].validate(async (valid)=>{
				if (valid) {
					this.form1.serviceTime= dayjs(this.form1.serviceTime).format('YYYY-MM-DD 00:00:00');
						let obj;let serviceid;
						if(!Number(this.form1.serviceType)){
							serviceid=this.options.find(ite=>ite.name==this.form1.serviceType).id;
							obj={
								...this.form,
								...this.form1,
								serviceType:serviceid
							}
						} else {
							obj={...this.form,...this.form1}
						}
						if(this.titState=='edit2'){
							obj.state=1;
						}
						// console.log(obj,'=======',this.form);
						this.isLoading = true;
						let res = await api.updateContinuityCare(obj);
						if (res.code != 1000) {return this.$message.error(res.message);}
						this.isLoading = false;
						this.$message.success('修改成功');
					this.closeDlg();
					this.form.servicer='';
					this.form.serviceTime='';
					this.form.serviceType='';
					setTimeout(() => {
						this.loadList();
					}, 500);
				}
			})
			
		},
		async delItem(item) {
			// 删除
			this.isLoading = true;
			let res = await api.delContinuityCare({continuityCareIds: item.id});
			this.isLoading = false;
			if (res.code != 1000) {
				return this.$message.error(res.message);
			}
			this.loadList();
			this.$message.success('已删除');
		},
		async delQuest(id){
				let res = await api.delQuestionnaireResult(id);
				if (res.code == 1000) {
					this.init();
					this.getQuestionResult(this.cid);
					// if(this.itemAdvice.followupState==3){
					// 	this.saveForm(3);
					// }
				}
			},
		handleSizeChange(v) {
			this.filter.pageSize = v;
			this.filter.pageNumber = 1;
			this.loadList();
		},
		handleCurrentChange(v) {
			this.filter.pageNumber = v;
			this.loadList();
		},
		handleVisiable(e){
				// 关闭新开页面，回到列表页，刷新列表数据
				if(e.target.visibilityState == "visible"){
					this.closeQuestionnaire();
				}
			}
	}
}
</script>

<style lang="less">
@import '@/assets/style/var';
.action{
	text-align: center;
}
.w-tabs {
	>.tabs {
		padding: 20px 30px;
		justify-content: space-between;
		.not-visit,
		.not-visit:focus,
		.not-visit:hover
		{
		border-color: #f56c6c;
		color:#f56c6c;
		margin-right: 0;
		}
	}
	
}
.step-title {
		padding: 15px 30px;
		border-bottom: 1px solid #F6F6F6;
		display: flex;
		justify-content: space-between;
		align-items: center;
		.rigBox{
			display: flex;
			i{
				font-size: 18px;
			}
			a{
				margin-right: 20px;
			}
		}
	}
.form-schedule {
	.el-form {
		border-bottom: 1px solid #f5f5f5;
		margin-bottom: 20px;
		&:last-child {
			border-bottom: 0;
		}
		.el-date-editor { margin-left: 0;}
		.el-textarea { width: 100%;}
		.el-select {
			.el-input {width: 300px; margin-right: 20px;}
		}
		
	}
}
</style>